import { PASSWORD_POLICY_MESSAGE } from "../authFieldPolicy";

export const RESET_PASSWORD_ALERT_TYPE = {
  RESET: 1,
  SUCCESS: 2,
  FAIL: 3,
};

export const RESET_PASSWORD_FLOW = {
  alertTitle: "Reset password",
  confirmMessage:
    "Are you sure you want to reset your password?\nA code will be sent to your registered email address.",
  successMessage:
    "A code has been sent to your registered email. You will be taken to a page to enter the code and your new password.",
  redirectPath: "/confirm-reset-password",
  redirectDelayMs: 5000,
};

export const RESET_PASSWORD_UI = {
  title: "Set new password",
  subtitle:
    "Enter the code from your password-reset email, then choose a new password. All fields are required.",
  successBannerTitle: "Password updated",
  successMessage: "You can now sign in with your new password.",
  successCtaLabel: "Go to sign in",
  missingSessionTitle: "Reset password",
  submitLabel: "Update password",
  submittingLabel: "Updating…",
  missingSessionMessage:
    'Missing session. Please use "Reset password" from the app again, then come back here with the link.',
  backToAppLabel: "Back to app",
  sessionMissingOnSubmit:
    "Session missing. Please request a new reset link from the app.",
  submitErrorMessage:
    "Invalid or expired code. Please request a new reset link and try again.",
  codeRequiredError: "Enter the code from your password-reset email.",
  passwordRequiredError: "Enter a password.",
  confirmPasswordRequiredError: "Re-enter the password to confirm it.",
  confirmPasswordMismatchError: "The two passwords do not match.",
  resetFields: [
    {
      name: "code",
      label: "Code from email",
      type: "text",
      required: true,
    },
    {
      name: "password",
      label: "New password",
      type: "password",
      required: true,
      info: PASSWORD_POLICY_MESSAGE,
      showPasswordToggle: true,
    },
    {
      name: "confirmPassword",
      label: "Confirm new password",
      type: "password",
      required: true,
      info: "Re-enter the same password.",
      showPasswordToggle: true,
    },
  ],
};
